export default __webpack_public_path__ + "static/media/loginfamilia.6a2e6225.svg";